// import React, { useEffect, useState } from "react";
// import RoomListTable from "./Components/RoomListTable";
// import AddRoom from "./Components/AddRoom";
// import EditRoom from "./Components/EditRoom";
// import api from "../../../../api/axios";
// import BackButton from "../../../Universal/Hotels/Components/BackButton";

// const RoomList = () => {
//   const [roomTypes, setRoomTypes] = useState([]);
//   const [rooms, setRooms] = useState([]);
//   const [amenities, setAmenities] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchAmenities = async () => {
//     try {
//       const res = await api.get("/pms/amenities");
//       setAmenities(res.data.data || []);
//     } catch (error) {
//       console.error("Failed to load amenities:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchRooms = async () => {
//     try {
//       const res = await api.get("/pms/rooms");
//       setRooms(res.data.data || []);
//     } catch (error) {
//       console.error("Failed to load rooms:", error);
//     }
//   };

//   const fetchRoomTypes = async () => {
//     try {
//       const res = await api.get("/pms/room-type");
//       setRoomTypes(res.data.data || []);
//     } catch (error) {
//       console.error("Failed to load room types:", error);
//     }
//   };

//   useEffect(() => {
//     fetchRoomTypes();
//     fetchRooms();
//     fetchAmenities();
//   }, []);

//   return (
//     <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
//       <div className="row g-3">
//         <div className="col-sm-12">
//           <BackButton />
//           <div className="d-flex align-items-center justify-content-between flex-wrap">
//             <h3 className="fw-bold mb-0">Room List</h3>
//             <div className="col-auto d-flex w-sm-100">
//               <button
//                 type="button"
//                 className="btn btn-dark"
//                 data-bs-toggle="offcanvas"
//                 data-bs-target="#add-room"
//                 aria-controls="add-room"
//               >
//                 Add Room
//               </button>
//             </div>
//           </div>
//         </div>
//         <div className="col-sm-12">
//           <div className="card">
//             <div className="card-body">
//               <RoomListTable rooms={rooms} loading={loading} />
//             </div>
//           </div>
//         </div>
//       </div>
//       <AddRoom
//         roomTypes={roomTypes}
//         fetchRooms={fetchRooms}
//         amenities={amenities}
//       />
//       <EditRoom
//         roomTypes={roomTypes}
//         fetchRooms={fetchRooms}
//         amenities={amenities}
//       />
//     </div>
//   );
// };

// export default RoomList;

// RoomList.jsx
import React, { useEffect, useState } from "react";
import api from "../../../../api/axios";
import BackButton from "../../../Universal/Hotels/Components/BackButton";
import AddRoom from "./Components/AddRoom";
import EditRoom from "./Components/EditRoom";
import RoomListTable from "./Components/RoomListTable";
import Swal from "sweetalert2";

const RoomList = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);

  const fetchRooms = async () => {
    setLoading(true);
    try {
      const res = await api.get("/pms/rooms");
      // handle common response shapes
      setRooms(res.data.data || res.data || []);
    } catch (err) {
      console.error("Failed to fetch rooms:", err);
      setRooms([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete room?",
      text: "This will permanently delete the room.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it",
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/pms/rooms/${id}`);
        Swal.fire({
          icon: "success",
          title: "Deleted",
          timer: 1200,
          showConfirmButton: false,
        });
        fetchRooms();
      } catch (err) {
        console.error("Delete failed:", err);
        Swal.fire({
          icon: "error",
          title: "Delete failed",
          text: err.response?.data?.message || "Something went wrong",
        });
      }
    }
  };

  const openEdit = (room) => {
    setSelectedRoom(room);
    setIsEditOpen(true);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <BackButton />

          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Rooms</h3>
            <button className="btn btn-dark" onClick={() => setIsAddOpen(true)}>
              Add Room
            </button>
          </div>
        </div>

        <div className="card mt-3">
          <div className="card-body">
            <RoomListTable
              data={rooms}
              loading={loading}
              onEdit={openEdit}
              onDelete={handleDelete}
            />
          </div>
        </div>

        <AddRoom
          open={isAddOpen}
          onClose={() => setIsAddOpen(false)}
          onAdded={fetchRooms}
        />
        <EditRoom
          open={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          room={selectedRoom}
          onUpdated={fetchRooms}
        />
      </div>
    </div>
  );
};

export default RoomList;
